import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = (multipart = false) => {

    const headers = { Authorization: `Bearer ${localStorage.getItem("token")}` }

    if (multipart) {
        headers["Content-Type"] = "multipart/form-data"
    }

    return { headers }
}


/* LIST — the reviews with the filters, the numbers of the platform and the points to watch */
export const list = data => {
    const uri = `${env.startpoint}/admin/review/list`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* GET — the whole review: photos, the visit, the point, the client and the complaints */
export const get = data => {
    const uri = `${env.startpoint}/admin/review/get`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* REPLY — the answer under the review, an empty text takes it away */
export const reply = data => {
    const uri = `${env.startpoint}/admin/review/reply`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* RESOLVE — the decision on a complaint of a point: 1 removes the review, 2 leaves it */
export const resolve = data => {
    const uri = `${env.startpoint}/admin/review/complaint/resolve`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* Prepare organizations for selection */
export const prepare = () => {
    const uri = `${env.startpoint}/admin/review/prepare`
    return axios.get(uri, auth()).then(response => response).catch(error => error.response)
}

/* Members of an organization */
export const members = data => {
    const uri = `${env.startpoint}/admin/review/members`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* Create */
export const create = data => {
    const uri = `${env.startpoint}/admin/review/create`
    return axios.post(uri, data, auth(true)).then(response => response).catch(error => error.response)
}

/* Edit */
export const edit = data => {
    const uri = `${env.startpoint}/admin/review/edit`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* Upload Image */
export const uploadImage = data => {
    const uri = `${env.startpoint}/admin/review/upload-image`
    return axios.post(uri, data, auth(true)).then(response => response).catch(error => error.response)
}

/* Remove Image */
export const removeImage = data => {
    const uri = `${env.startpoint}/admin/review/remove-image`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* Remove */
export const remove = data => {
    const uri = `${env.startpoint}/admin/review/remove`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}
